import { makeObservable, action } from "mobx";
import { Project } from '../api';
import axios from 'axios';
import { getAccessToken } from './../api/config';

export default class ProjectStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      getProjects: action,
      getProjectByClient: action,
      getProjectByProfessional: action,
      updateProjectById: action
    });
  }

  async getProjects(lastId, navId ) {
    try {
      const retObj = await Project.getProjects(lastId, navId);
      return retObj.data.response.projects;
    } catch (error) {
      console.error("Error in getProjects:", error);
      throw error;
    }
  }

  async getProjectsByFilters(searchString, startYear, endYear, lastId, navId, i , type) {
    
    if (!type)type = "";
    if (!i)i = "";
    try {
      const retObj = await Project.getProjectsByFilters(searchString, startYear, endYear, lastId, navId, i, type);
      return retObj.data.response.projects;
    } catch (error) {
      console.error("Error in getProjectsByFilters:", error);
      throw error;
    }
  }
  async getProjectByClient(id) {
    try {
      const retObj = await Project.getProjectByClient(id);
      return retObj.data.response.projects;
    } catch (error) {
      console.error("Error in getProjectByClient:", error);
      throw error;
    }
  }
  async getProjectByProfessional(id) {
    try {
      const retObj = await Project.getProjectByProfessional(id);
      return retObj.data.response.projects;
    } catch (error) {
      console.error("Error in getProjectByProfessional:", error);
      throw error;
    }
  }
  async updateProjectById(id, data) {
    try {
      const retObj = await Project.updateProjectById(id, data);
      return retObj.data.response;
    } catch (error) {
      console.error("Error in updateProjectById:", error);
      throw error;
    }
  }

   // Direct Axios call for updating a brief
    async updateProjectByIdDirect(id, data) {
      try {
        const token = getAccessToken() || '';
        const response = await axios.patch(
          `http://localhost:7002/project/id/${id}`,
          data,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );
  
        return response.data;
      } catch (err) {
        console.error('Axios direct error:', err.response?.data || err.message);
        throw err;
      }
    }
}
